// jQuery plugin to highlight an element by
// adding and then removing a highlighting class.
//
// valid highlightType values are 'error' and 'update'
// if not given, we default to update
//
// example:
//    $(foo).highlight();
//    $(foo).highlight('error');
//
// This plugin assumes the presence of update-highlight and error-highlight
// css classes that look something like this:
//
// .update-highlight {
//   @include transition(background-color, 1s, linear);
//   background-color: yellow;
// }
//
// The element being highlighted should have a background transition also so that
// it fades out when the highlight class is removed.
$.fn.highlight = function (highlightType) {
  if (!highlightType) { highlightType = 'update'; }
  const highlightClass = `${highlightType}-highlight`;
  const element = this;

  element.addClass(highlightClass);
  setTimeout(() => { element.removeClass(highlightClass); }, 750);
  return element;
};
